module.exports = __webpack_public_path__ + "static/media/product2.4b367f59.webp";